// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"loading_spinnerContainer__3QXCZ","spinner":"loading_spinner__2C3Nd"};